import { IsNumber, IsOptional, IsString } from 'class-validator';

export class FireOpenRefundRequestDto {
  @IsNumber()
  merchantId: number;

  @IsNumber()
  ican: number;

  @IsNumber()
  amount: number;

  @IsString()
  myRef: string;

  @IsString()
  accountName: string;  

  @IsString()
  @IsOptional()
  iban?: string;

  @IsString()
  @IsOptional()
  accountNumber?: string;

  @IsString()
  @IsOptional()
  sortCode?: string;

  @IsString()
  @IsOptional()
  currency?: string;

  @IsString()
  @IsOptional()
  yourRef?: string;

}